// 盤面定数（データ駆動）
export const BOARD_SIZE = 9
export const WIN_LENGTH = 5
